<template>
  <div v-if="isLoading" class="global-loading-overlay">
    <div class="global-loading-sheet">
      <div class="loader"></div>
      <div class="mt-7">Loading</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState({
            isLoading: state => state.general.isLoading
        })
    }
}
</script>

<style>
.loader {
  border: 10px solid #f3f3f3;
  border-top: 10px solid #4caf50;
  border-radius: 50%;
  margin: 5px auto;
  width: 100px;
  height: 100px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* ใช้ overlay ของตัวเองแทน v-dialog เพราะ overlayable mixin ของ Vuetify
   จะ addEventListener('wheel', ..., { passive: false }) บน window ตอนเปิด dialog
   บน desktop แล้ว preventDefault ทั้งหน้า ถ้า showScroll ไม่ถูกเรียกคู่กัน
   (เช่นตอน gristApiFire ยิงรัวใน loop) listener จะค้าง ทำให้ scroll ทั้งหน้าไม่ได้
   ต้องแสดงเหนือ custom modal overlay ทุกตัวในแอป (z-index: 9999) */
.global-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 20000;
  background: rgba(0, 0, 0, 0.46);
  display: flex;
  align-items: center;
  justify-content: center;
}

.global-loading-sheet {
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  width: 300px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
